import { AuthGuard, NonAuthGuard, RouteExtended } from '@controladad/ng-base';

export const appRoutes: RouteExtended[] = [
  {
    path: 'login',
    loadComponent: () => import('@panel').then((t) => t.LoginComponent),
    canActivate: [NonAuthGuard],
  },
  {
    path: '',
    layout: 'main',
    loadComponent: () => import('@panel').then((t) => t.MainLayoutComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        view: {
          label: 'Dashboard',
          icon: { default: 'layout-dashboard', active: 'layout-dashboard' },
        },
        loadComponent: () => import('@panel').then((t) => t.DashboardComponent),
      },
      {
        path: 'orders',
        view: {
          label: 'Orders',
          icon: { default: 'receipt-2', active: 'receipt-2' },
        },
        data: { isAdmin: true },
        loadComponent: () => import('@panel').then((t) => t.OrdersComponent),
      },
      {
        path: 'wallet-transactions',
        view: {
          label: 'Wallet',
          icon: { default: 'wallet', active: 'wallet' },
        },
        loadComponent: () => import('@panel').then((t) => t.WalletTransactionsComponent),
      },
      {
        path: 'users',
        view: {
          label: 'Users',
          icon: 'users',
        },
        children: [
          {
            path: 'admin',
            view: {
              label: 'Admin Users',
              icon: { default: 'user-shield', active: 'user-shield' },
            },
            loadComponent: () => import('@panel').then((t) => t.AdminUsersComponent),
          },
          {
            path: 'customers',
            view: {
              label: 'Customers',
              icon: 'user',
            },
            loadComponent: () => import('@panel').then((t) => t.CustomerUsersComponent),
          },
          {
            path: 'vendors',
            view: {
              label: 'Vendors',
              icon: { default: 'building-store', active: 'building-store' },
            },
            loadComponent: () => import('@panel').then((t) => t.VendorUsersComponent),
          },
        ],
      },
      {
        path: 'catalog',
        view: {
          label: 'Catalog',
          icon: { default: 'packages', active: 'packages' },
        },
        children: [
          {
            path: 'attributes',
            view: {
              label: 'Attributes',
            },
            children: [
              {
                path: 'attributes',
                view: {
                  label: 'Attributes',
                  icon: { default: 'settings-2', active: 'settings-2' },
                },
                loadComponent: () => import('@panel').then((t) => t.AttributesComponent),
              },
              {
                path: 'sets',
                view: {
                  label: 'Attribute Sets',
                  icon: { default: 'layers-linked', active: 'layers-linked' },
                },
                loadComponent: () => import('@panel').then((t) => t.AttributeSetComponent),
              },
            ],
          },
          {
            path: 'products',
            view: {
              label: 'Products',
              icon: { default: 'box', active: 'box' },
            },
            data: { isAdmin: true },
            loadComponent: () => import('@panel').then((t) => t.ProductsComponent),
          },
          {
            path: 'categories',
            view: {
              label: 'Categories',
              icon: { default: 'category', active: 'category' },
            },
            loadComponent: () => import('@panel').then((t) => t.CategoryComponent),
          },
          {
            path: 'brands',
            view: {
              label: 'Brands',
              icon: { default: 'certificate', active: 'certificate' },
            },
            loadComponent: () => import('@panel').then((t) => t.BrandComponent),
          },
          {
            path: 'rails',
            view: {
              label: 'Product Rails',
              icon: { default: 'list', active: 'list' },
            },
            loadComponent: () => import('@panel').then((t) => t.RailsComponent),
          }
        ],
      },
      {
        path: 'content',
        view: {
          label: 'Content',
          icon: { default: 'file-description', active: 'file-description' },
        },
        children: [
          {
            path: 'banners',
            view: {
              label: 'Banners',
              icon: { default: 'ad', active: 'ad' },
            },
            permittedRoles: ['Admin', 'ShopAdmin', 'ContentManagement'],
            loadComponent: () => import('@panel').then((t) => t.BannersComponent),
          },
          {
            path: 'about-us',
            view: {
              label: 'About Us',
              icon: 'info-circle',
            },
            loadComponent: () => import('@panel').then((t) => t.AboutUsComponent),
          },
          {
            path: 'delivery-information',
            view: {
              label: 'Delivery Information',
              icon: { default: 'truck', active: 'truck' },
            },
            loadComponent: () => import('@panel').then((t) => t.DeliveryInfoComponent),
          },
          {
            path: 'terms-condition',
            view: {
              label: 'Terms And Condition',
              icon: { default: 'file-description', active: 'file-description' },
            },
            loadComponent: () => import('@panel').then((t) => t.TermsConditionComponent),
          },
          {
            path: 'privacy-policy',
            view: {
              label: 'Privacy Policy',
              icon: { default: 'shield-lock', active: 'shield-lock' },
            },
            loadComponent: () => import('@panel').then((t) => t.PrivacyPolicyComponent),
          },
          {
            path: 'support',
            view: {
              label: 'Support',
              icon: { default: 'lifebuoy', active: 'lifebuoy' },
            },
            loadComponent: () => import('@panel').then((t) => t.SupportComponent),
          },
          {
            path: 'blogs',
            view: { label: 'Blogs', icon: { default: 'news', active: 'news' } },
            loadComponent: () => import('@panel').then((t) => t.BlogsComponent),
          },
        ],
      },
      {
        path: 'list',
        view: {
          label: 'Reviews',
          icon: { default: 'stars', active: 'stars' },
        },
        loadComponent: () => import('@panel').then((t) => t.ReviewsListComponent),
      },
      {
        path: 'notification',
        view: {
          label: 'Notification',
          icon: { default: 'push-notification', active: 'push-notification' },
        },
        loadComponent: () => import('@panel').then((t) => t.PushNotificationComponent),
      },
      {
        path: 'reports',
        view: {
          label: 'Reports',
          icon: { default: 'chart-bar', active: 'chart-bar' },
        },
        children: [
          {
            path: 'order-items',
            view: {
              label: 'Order Items Report',
              icon: { default: 'report', active: 'report' },
            },
            loadComponent: () => import('@panel').then((t) => t.OrderItemsReportComponent),
          },
        ],
      },
      {
        path: 'configurations',
        view: {
          label: 'Settings',
          icon: 'settings',
        },
        children: [
          {
            path: 'delivery-time',
            view: { label: 'Delivery Time Settings', icon: 'time' },
            loadComponent: () => import('@panel').then(t => t.DeliveryTimeSettingsComponent),
          },
          {
            path: 'cart-rules',
            view: { label: 'Cart Rules', icon: { default: 'shopping-cart', active: 'shopping-cart' } },
            loadComponent: () => import('@panel').then((t) => t.CartRulesComponent),
          },
          {
            path: 'coupon-codes',
            view: { label: 'Coupon Code', icon: { default: 'ticket', active: 'ticket' } },
            loadComponent: () => import('@panel').then((t) => t.CouponComponent),
          },
          {
            path: 'payment-methods',
            view: { label: 'Payment Methods', icon: { default: 'credit-card', active: 'credit-card' } },
            loadComponent: () => import('@panel').then((t) => t.PaymentMethodsComponent),
          },
          {
            path: 'governorates',
            view: { label: 'Governorates', icon: { default: 'map', active: 'map' } },
            loadComponent: () => import('@panel').then((t) => t.GovernoratesComponent),
          },
          {
            path: 'google-feed',
            view: { label: 'Google Feed', icon: { default: 'external-link', active: 'external-link' } },
            loadComponent: () => import('@panel').then((t) => t.GoogleFeedSettingsComponent),
          },
        ],
      },
    ],
  },
];
